/// <reference path="./custom-window.d.ts" />
import * as FilePond from 'filepond';
import FilePondPluginFileEncode from 'filepond-plugin-file-encode';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';


interface HtmxConfigRequestEvent extends Event {
  detail: {
    parameters: FormData;
  };
}

window.PLDragAndDropInstall = function (id, title, btnText, accept, isDisabled, icon, separator) {
  const form = document.getElementById(id) as HTMLFormElement;
  const inputElement = form?.querySelector('input[type="file"]') as HTMLInputElement;
  const toast = document.getElementById(id + separator + "toast") as HTMLElement;

  if (!inputElement || !form) return;
  form.setAttribute("hx-swap", "none");

  let fileQueue: Blob[] = [];
  let currentFile: Blob | null = null;
  let isUploading = false;

  FilePond.registerPlugin(
    FilePondPluginImagePreview,
    FilePondPluginFileEncode,
    FilePondPluginFileValidateSize,
    FilePondPluginImageExifOrientation,
    FilePondPluginFileValidateType
  );

  const processNextFile = () => {
    if (isUploading || fileQueue.length === 0) {
      if (toast) toast.style.display = 'none'
      return
    };

    isUploading = true;
    if (toast)
      toast.style.display = 'block'
    currentFile = fileQueue.shift()!;

    if (form) {
      if (fileQueue.length === 0) {
        form.setAttribute("hx-swap", "outerHTML");
      } else {
        form.setAttribute("hx-swap", "none");
      }
    }

    window.htmx.trigger('#' + id, 'submit');
  };

  FilePond.create(inputElement, {
    credits: false, // Should link to https://pqina.nl somewere on the page when credits are disabled. https://pqina.nl/filepond/docs/api/instance/properties/#disabling-credits
    dropOnPage: true,
    allowMultiple: true,
    allowDrop: true,
    disabled: isDisabled,
    labelIdle: `<div id="filepondWrapper">
                  ${icon ? `<img src=${icon} alt="Ikon ladda upp" style="display: block;">` : ""}
                  ${title}
                  <span class="filepond--label-action btn-hover">${btnText || "Välj filer"}</span>
                </div>`,
    acceptedFileTypes: accept,
    allowFileSizeValidation: true,
    maxFileSize: '30mb',
    labelFileTypeNotAllowed: "Filen är inte av rätt typ",
    labelMaxFileSizeExceeded: 'Fil är för stor',
    labelMaxFileSize: `Fil är för stor, max storlek är 30mb`,
    //maxTotalFileSize: '30mb',
    //labelMaxTotalFileSizeExceeded: `Filerna är för stora, max storlek är 30mb`,
    //labelMaxTotalFileSize: `Filerna är för stora, max storlek är 30mb`,
    server: {
      process: (fieldName, file, metadata, load, error, progress, abort) => {
        if (form.getAttribute("hx-swap") === "outerHTML") {
          form.setAttribute("hx-swap", "none");
        }
        fileQueue.push(file);
        processNextFile();
        load('ok');
      }
    }
  });

  form.addEventListener("htmx:configRequest", (event: Event) => {
    const htmxEvent = event as HtmxConfigRequestEvent;
    const formData = new FormData();

    if (currentFile) {
      formData.append('file', currentFile, (currentFile as any).name);
    }
    htmxEvent.detail.parameters = formData;
  });

  document.body.addEventListener("htmx:afterOnLoad", () => {
    isUploading = false;
    currentFile = null;
    processNextFile();
  });
};

console.log('PLDragAndDrop has been installed')